import { Component, Inject, SecurityContext } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ChangeDetectorRef, NgZone, ViewChild } from '@angular/core';

import { RouterLink } from '@angular/router/src/directives/router_link';
import { retry } from 'rxjs/operator/retry';
import { DatePipe } from '@angular/common'
import { PersistenceService, StorageType } from 'angular-persistence';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'Default',
  templateUrl: './Default.html'
})
export class DefaultTS {
  public http: HttpClient;
  public baseUrl: string;
  public Message = '';

  public Years = [{ PID: 2024, Name: '2024/25' }, { PID: 2025, Name: '2025/26' }, { PID: 2026, Name: '2026/27' }, { PID: 2027, Name: '2027/28' }];
  public Quarters = [{ PID: 1, Name: 'Q1', ShortName: "Q1" }, { PID: 2, Name: 'Q2', ShortName: "Q2" },
  { PID: 3, Name: 'Q3', ShortName: "Q3" }, { PID: 4, Name: 'Q4', ShortName: "Q4" }];
  public MonthNames = [{ PID: 1, Name: 'January', ShortName: "Jan" }, { PID: 2, Name: 'February', ShortName: "Feb" },
  { PID: 3, Name: 'March', ShortName: "Mar" }, { PID: 4, Name: 'April', ShortName: "Apr" }, { PID: 5, Name: 'May', ShortName: "May" },
  { PID: 6, Name: 'June', ShortName: "Jun" }, { PID: 7, Name: 'July', ShortName: "Jul" }, { PID: 8, Name: 'August', ShortName: "Aug" },
  { PID: 9, Name: 'September', ShortName: "Sep" }, { PID: 10, Name: 'October', ShortName: "Oct" }, { PID: 11, Name: 'November', ShortName: "Nov" },
  { PID: 12, Name: 'December', ShortName: "Dec" }];

  public UserEmail = '';
  public AccessStatus = 1;
  public IsReadOnly = true;
  public IsFinanceManager = false;
  public IsTechnicalTrainer = false;
  public IsNonTechnicalTrainer = false;
  public IsResourceManager = false;
  public CanApproveAndSubmit = false;
  public CanManageContentLibrary = false;
  public IsNonTechnicalAssessor = false;
  public CanManageDashboardImage = false;
  public IsAdmin = false;
  public IsJLR = false;
  public IsDealer = false;
  public PFIDealerID = 0;
  public DealerName = '';
  public SiteUserID = 0;
  public IsLocal = false;
  public LoginUserKey = '';
  public FileUploaderStatus = 0;

  constructor(public datepipe: DatePipe, private persistenceService: PersistenceService, http: HttpClient, @Inject('BASE_URL') baseUrl: string, private Sanitizer: DomSanitizer) {
    this.http = http;
    this.baseUrl = baseUrl;

    var SiteUserID = this.persistenceService.get('SiteUserID', StorageType.SESSION);
    //this.UserEmail = this.persistenceService.get('UserEmail', StorageType.SESSION);
    //this.PFIDealerID = this.persistenceService.get('PFIDealerStorageID', StorageType.SESSION);
    //this.IsReadOnly = this.persistenceService.get('IsReadOnly', StorageType.SESSION);
    //this.IsFinanceManager = this.persistenceService.get('IsFinanceManager', StorageType.SESSION);
    //this.CanApproveAndSubmit = this.persistenceService.get('CanApproveAndSubmit', StorageType.SESSION);
    //this.IsTechnicalTrainer = this.persistenceService.get('IsTechnicalTrainer', StorageType.SESSION);
    //this.IsNonTechnicalTrainer = this.persistenceService.get('IsNonTechnicalTrainer', StorageType.SESSION);
    //this.IsResourceManager = this.persistenceService.get('IsResourceManager', StorageType.SESSION);
    //this.IsNonTechnicalAssessor = this.persistenceService.get('IsNonTechnicalAssessor', StorageType.SESSION);
    //this.CanManageDashboardImage = this.persistenceService.get('CanManageDashboardImage', StorageType.SESSION);

    //if (this.PFIDealerID > 0) {
    //  this.IsDealer = true;
    //}
    //else {
    //  this.IsDealer = false;
    //}
  }

  public ConvertServerDateToLocalDate(p_oDate) {

    var l_oDate = new Date(p_oDate); // val is in UTC
    var localOffset = l_oDate.getTimezoneOffset() * 60000;
    var localTime = l_oDate.getTime() - localOffset;

    l_oDate.setTime(localTime);
    return l_oDate.toLocaleString();
    //return new Date(Date.UTC(p_oDate.getFullYear(), p_oDate.getMonth(), p_oDate.getDate(), p_oDate.getHours(), p_oDate.getMinutes(), p_oDate.getSeconds())).toLocaleString();

    //var l_oNewDate = new Date(p_oDate.getTime() + p_oDate.getTimezoneOffset() * 60 * 1000);

    //var l_intOffset = p_oDate.getTimezoneOffset() / 60;
    //var l_intHours = p_oDate.getHours();
    //l_oNewDate.setHours(l_intHours - l_intOffset);

    //return l_oNewDate.toLocaleString();
  }
  public ConvertServerDateToLocalDateString(p_oDate) {
    var l_oDate = new Date(p_oDate); // val is in UTC
    var localOffset = l_oDate.getTimezoneOffset() * 60000;
    var localTime = l_oDate.getTime() - localOffset;

    l_oDate.setTime(localTime);
    return l_oDate.toLocaleDateString();
    //return new Date(Date.UTC(p_oDate.getFullYear(), p_oDate.getMonth(), p_oDate.getDate(), p_oDate.getHours(), p_oDate.getMinutes(), p_oDate.getSeconds())).toLocaleDateString();

  }
  public ConvertServerTimeZoneToLocalTimeZone(p_oDate) {
    var l_oDate = new Date(p_oDate); // val is in UTC
    var localOffset = l_oDate.getTimezoneOffset() * 60000;
    var localTime = l_oDate.getTime() - localOffset;

    l_oDate.setTime(localTime);
    return l_oDate;
  }

  public ConvertServerTimeZoneToLocalTimeZoneUsingJson(p_oGridData, p_strColumnName) {

    var l_oArrayOfUniqueValues = [];
    var l_intCount = 0;
    if (p_oGridData) {
      for (var i = 0; i < p_oGridData.length; i++) {
        l_oArrayOfUniqueValues[l_intCount] = Object.assign({}, p_oGridData[l_intCount]);
        var l_strValue = l_oArrayOfUniqueValues[l_intCount][eval('p_strColumnName')];
        if (l_strValue.toString().indexOf('1900') > -1) {
          l_strValue = '';
          l_oArrayOfUniqueValues[l_intCount][eval('p_strColumnName')] = l_strValue;
        }
        if (l_strValue != ' ' && l_strValue != '' && l_strValue != null) {

          var l_oDate = new Date(l_strValue); // val is in UTC
          var localOffset = l_oDate.getTimezoneOffset() * 60000;
          var localTime = l_oDate.getTime() - localOffset;

          l_oDate.setTime(localTime);
          l_oArrayOfUniqueValues[l_intCount][eval('p_strColumnName')] = l_oDate;
        }
        l_intCount++;
      }
    }
    return l_oArrayOfUniqueValues;
  }

  public GetDifferenceBetweenTwoDates(p_strStartDate, p_strEndDate) {
    // get total seconds between the times

    var delta = Math.abs(p_strEndDate - p_strStartDate) / 1000;

    // calculate (and subtract) whole days
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    // what's left is seconds
    var seconds = Math.floor(delta % 60); // in theory the modulus is not required

    return [days, hours, minutes, seconds];
  }

  public GetDifferenceBetweenTwoDatesWithoutWeekends(p_oStartDate, p_oEndDate) {
    //debugger;
    var elapsed, daysBeforeFirstSaturday, daysAfterLastSunday;
    var ifThen = function (a, b, c) {
      return a == b ? c : a;
    };

    elapsed = p_oEndDate - p_oStartDate;
    elapsed /= 86400000;

    daysBeforeFirstSaturday = (7 - p_oStartDate.getDay()) % 7;
    daysAfterLastSunday = p_oEndDate.getDay();

    elapsed -= (daysBeforeFirstSaturday + daysAfterLastSunday);
    elapsed = (elapsed / 7) * 5;
    elapsed += ifThen(daysBeforeFirstSaturday - 1, -1, 0) + ifThen(daysAfterLastSunday, 6, 5);

    return Math.ceil(elapsed);
  }

  public IsDateBetweenTwoDates(p_oStartDate, p_oToCheckDate, p_oEndDate) {
    p_oStartDate = new Date(p_oStartDate);
    p_oStartDate = p_oStartDate.setHours(0, 0, 0, 0);
    p_oToCheckDate = new Date(p_oToCheckDate);
    p_oToCheckDate = p_oToCheckDate.setHours(0, 0, 0, 0);
    p_oEndDate = new Date(p_oEndDate);
    p_oEndDate = p_oEndDate.setHours(0, 0, 0, 0);
    if (p_oStartDate <= p_oToCheckDate && p_oToCheckDate <= p_oEndDate) {
      return true;
    }
    else
      return false;
  }

  public IsDateTimeBetweenTwoDates(p_oStartDate, p_oToCheckDate, p_oEndDate) {
    p_oStartDate = new Date(p_oStartDate);
    //p_oStartDate = p_oStartDate.setHours(0, 0, 0, 0);
    p_oToCheckDate = new Date(p_oToCheckDate);
    //p_oToCheckDate = p_oToCheckDate.setHours(0, 0, 0, 0);
    p_oEndDate = new Date(p_oEndDate);
    //p_oEndDate = p_oEndDate.setHours(0, 0, 0, 0);
    if (p_oStartDate <= p_oToCheckDate && p_oToCheckDate <= p_oEndDate) {
      return true;
    }
    else
      return false;
  }

  public FormatDateInUKFormat(p_oDate) {
    return this.datepipe.transform(p_oDate, 'dd/MM/yyyy');
  }

  public FormatDateInUKFormatUsingJson(p_oGridData, p_strColumnName) {
    var l_oArrayOfUniqueValues = [];
    var l_intCount = 0;
    if (p_oGridData) {
      debugger;
      for (var i = 0; i < p_oGridData.length; i++) {
        l_oArrayOfUniqueValues[l_intCount] = Object.assign({}, p_oGridData[l_intCount]);
        var l_strValue = l_oArrayOfUniqueValues[l_intCount][eval('p_strColumnName')];
        if (l_strValue.toString().indexOf('1900') > -1) {
          l_strValue = '';
          l_oArrayOfUniqueValues[l_intCount][eval('p_strColumnName')] = l_strValue;
        }
        if (l_strValue != ' ' && l_strValue != '' && l_strValue != null) {
          var l_arrSplittedDate = l_strValue.toString().split('/');
          if (l_arrSplittedDate.length > 0) {
            var l_oDate = new Date(l_arrSplittedDate[1] + '/' + l_arrSplittedDate[0] + '/' + l_arrSplittedDate[2]); // val is in UTC
            var localOffset = l_oDate.getTimezoneOffset() * 60000;
            var localTime = l_oDate.getTime() - localOffset;

            l_oDate.setTime(localTime);
            l_oDate.setHours(0, 0, 0, 0);
            l_oArrayOfUniqueValues[l_intCount][eval('p_strColumnName')] = l_oDate;
          }
          else
            l_oArrayOfUniqueValues[l_intCount][eval('p_strColumnName')] = l_strValue;
        }
        l_intCount++;
      }
    }
    return l_oArrayOfUniqueValues;
  }

  public isEndDateAfterStartDate(p_dtStartDate, p_dtEndDate) {
    if (p_dtEndDate.getTime() >= p_dtStartDate.getTime()) {
      return true;
    }
    return false;
  }

  //MM:: Is Date in proper format
  public isValidDate(d) {
    return d instanceof Date && !isNaN(d.getTime());
  }
  //MM:: Get Unique Records Against The Column from OverAll Data
  public GetUniqueJsonRecordsAgainstNthColumn(p_oGridData, p_strColumnName) {

    var lookup = {};
    var l_oArrayOfUniqueValues = [];
    for (var item, i = 0; item = p_oGridData[i++];) {
      var name = item[eval('p_strColumnName')];

      if (!(name in lookup) && name != '') {
        lookup[name] = 1;
        l_oArrayOfUniqueValues.push(item);
      }
    }
    return l_oArrayOfUniqueValues;
  }

  //MM:: Get Unique Records Against The Column from OverAll Data
  public GetUniqueRecordsAgainstNthColumn(p_oGridData, p_strColumnName) {

    var lookup = {};
    var l_oArrayOfUniqueValues = [];
    for (var item, i = 0; item = p_oGridData[i++];) {
      var name = item[eval('p_strColumnName')];
      if (name != '') {
        if (!(name in lookup)) {
          lookup[name] = 1;
          l_oArrayOfUniqueValues.push(name);
        }
      }
    }
    return l_oArrayOfUniqueValues.sort();
  }

  //MM:: Get Unique Records Against The Column from OverAll Data
  public GetUniqueRecordsAgainstNthColumnWithoutSort(p_oGridData, p_strColumnName) {

    var lookup = {};
    var l_oArrayOfUniqueValues = [];
    for (var item, i = 0; item = p_oGridData[i++];) {
      var name = item[eval('p_strColumnName')];

      if (!(name in lookup)) {
        lookup[name] = 1;
        l_oArrayOfUniqueValues.push(name);
      }
    }
    return l_oArrayOfUniqueValues;
  }

  //MM:: Get Unique Records Against The Column from OverAll Data
  public GetUniqueValuesAgainstNthColumn(p_oGridData, p_strColumnName) {

    var lookup = {};
    var l_oArrayOfUniqueValues = [];
    for (var item, i = 0; item = p_oGridData[i++];) {
      var name = item[eval('p_strColumnName')];

      if (!(name in lookup)) {
        lookup[name] = 1;
        l_oArrayOfUniqueValues.push(item);
      }
    }
    return l_oArrayOfUniqueValues;
  }

  public FilterJsonExactlyMatching(p_oGridData, p_oColumn, p_strValue) {
    var l_arrFilteredData = [];
    var count = 0;
    if (p_oGridData) {
      for (var i = 0; i < p_oGridData.length; i++) {
        if (p_oGridData[i][p_oColumn] == p_strValue) {
          l_arrFilteredData[count] = p_oGridData[i];
          count++;
        }
      }
    }
    return l_arrFilteredData;
  }

  public FilterJsonExactlyMatchingDates(p_oGridData, p_oColumn, p_strValue) {
    var l_arrFilteredData = [];
    var count = 0;

    for (var i = 0; i < p_oGridData.length; i++) {
      if (p_strValue != '' && p_strValue != null && p_strValue != ' ') {
        if (p_oGridData[i][p_oColumn] != ' ') {
          var l_oEnteredDate = new Date(p_strValue);
          var l_oDateInDatabase = new Date(p_oGridData[i][p_oColumn]);
          l_oEnteredDate.setHours(0, 0, 0, 0);
          l_oDateInDatabase.setHours(0, 0, 0, 0);
          if (l_oEnteredDate.getTime() == l_oDateInDatabase.getTime()) {
            l_arrFilteredData[count] = p_oGridData[i];
            count++;
          }
        }
      }
    }
    return l_arrFilteredData;
  }

  public GetValueExactlyMatchingColumn(p_oGridData, p_oColumn, p_strValue, p_strReturnValueColumn) {
    var l_strValue = '';
    var count = 0;
    if (p_oGridData) {
      for (var i = 0; i < p_oGridData.length; i++) {
        if (p_oGridData[i][p_oColumn] == p_strValue) {
          l_strValue = p_oGridData[i][p_strReturnValueColumn];
          break;
        }
      }
    }
    return l_strValue;
  }

  //  AR  Show/ Hide a dive/////

  public PTSetVisibilty(p_strDivID, p_boolShow) {

    var l_strVisibility = "none";
    if (p_boolShow) {

      l_strVisibility = "block";

    }
    if (document.getElementById(p_strDivID) != null)
      document.getElementById(p_strDivID).style.display = l_strVisibility;

  }

  public PTSetVisibiltyTableRow(p_strDivID, p_boolShow) {

    var l_strVisibility = "none";
    if (p_boolShow) {

      l_strVisibility = "table-row";

    }
    if (document.getElementById(p_strDivID) != null)
      document.getElementById(p_strDivID).style.display = l_strVisibility;

  }


  public PTSetVisibilityAsHiddenOrVisible(p_strDivID, p_boolShow) {

    var l_strVisibility = "hidden";
    if (p_boolShow) {

      l_strVisibility = "visible";

    }
    document.getElementById(p_strDivID).style.visibility = l_strVisibility;

  }

  public getDateForComparison(p_strDateToConvert) {
    var l_arrSplittedDate = p_strDateToConvert.split('/');
    var l_dtToReturn = new Date(l_arrSplittedDate[2], parseInt(l_arrSplittedDate[1]) - 1, l_arrSplittedDate[0]);

    return l_dtToReturn;
  }

  //  AR  Show/ Hide a dive/////

  //MM:: ConvertSlashesSeperatedStringsToDates
  public ConvertSlashesSeperatedStringsToDates(p_oGridData, p_strColumnName) {

    var l_oArrayOfUniqueValues = [];
    var l_intCount = 0;
    for (var i = 0; i < p_oGridData.length; i++) {
      l_oArrayOfUniqueValues[l_intCount] = Object.assign({}, p_oGridData[l_intCount]);

      var l_strValue = l_oArrayOfUniqueValues[l_intCount][eval('p_strColumnName')];
      if (l_strValue != ' ' && l_strValue != '' && l_strValue != null) {
        var l_arrSplittedData = l_strValue.split('/');

        if (l_arrSplittedData.length > 1) {
          var l_oDate = new Date(l_arrSplittedData[2], (l_arrSplittedData[1] - 1), l_arrSplittedData[0]);
          l_oArrayOfUniqueValues[l_intCount][eval('p_strColumnName')] = l_oDate;
        }
      }
      l_intCount++;
    }
    return l_oArrayOfUniqueValues;
  }

  //MM:: ConvertSlashesSeperatedStringsToDates
  public AssignGridDataValuesToOtherGridData(p_oGridData) {

    //var l_oArrayOfUniqueValues = [];
    //var l_intCount = 0;
    //if (p_oGridData != undefined) {
    //  for (var item, i = 0; item = p_oGridData[i++];) {
    //    l_oArrayOfUniqueValues[l_intCount] = p_oGridData[l_intCount];
    //    l_intCount++;
    //  }
    //}
    //return l_oArrayOfUniqueValues;

    return JSON.parse(JSON.stringify(p_oGridData));
  }

  public GetIndexExactlyMatchingColumn(p_oGridData, p_oColumn, p_strValue) {
    var l_arrFilteredData = [];
    var index = -1;
    for (var i = 0; i < p_oGridData.length; i++) {
      if (p_oGridData[i][p_oColumn] == p_strValue) {
        index = i;
        break;
      }
    }
    return index;
  }


  public RemoveSelectedChildFromList(p_oGridData, p_oColumn, p_strValue) {
    var l_arrFilteredData = [];
    var index = -1;
    for (var i = 0; i < p_oGridData.length; i++) {
      if (p_oGridData[i][p_oColumn] == p_strValue) {
        index = i;
        break;
      }
    }
    if (index > -1) {
      p_oGridData.splice(index, 1);
    }
    return p_oGridData;
  }

  public SetMasterAnimation(l_boolShow) {
    if (l_boolShow)
      document.getElementById('Animation').style.display = '';
    else
      document.getElementById('Animation').style.display = 'none';
  }
  public ShowAlert(p_strMessage) {
    this.Message = p_strMessage;
    document.getElementById("ShowModal").click();
    document.getElementById("Message").innerHTML = p_strMessage;
  }

  public GetColumnNamesFromJson(p_oGridData) {
    var l_arrColumns = [];
    var l_intCounter = 0;
    for (let obj of p_oGridData) {
      for (let key in obj) {
        if (key.toString().toLowerCase().indexOf('id') < 0) {
          l_arrColumns[l_intCounter] = key;
          l_intCounter++;
        }
      }
      break;
    }
    return l_arrColumns;
  }


  public GetColumnNamesFromJsonWithIDs(p_oGridData) {
    var l_arrColumns = [];
    var l_intCounter = 0;
    for (let obj of p_oGridData) {
      for (let key in obj) {
        l_arrColumns[l_intCounter] = key;
        l_intCounter++;
      }
      break;
    }
    return l_arrColumns;
  }

  //////////// AR: Checkboxes/RadioButtons functions starts /////////

  public GetSelectedIDsFromList(p_strID) {

    var l_intSelectedIDs = "-1";
    let l_strList = <any>document.getElementsByName(p_strID);

    for (var i = 0, length = l_strList.length; i < length; i++) {
      if (l_strList[i].checked) {

        l_intSelectedIDs = l_intSelectedIDs + "," + l_strList[i].value;

      }
    }
    l_intSelectedIDs = l_intSelectedIDs.replace("-1,", "");
    return l_intSelectedIDs;
  }

  public SelectUnSelectSpecificElement(p_strID, p_intValue, p_boolSelect) {

    let l_strList = <any>document.getElementsByName(p_strID);

    for (var i = 0, length = l_strList.length; i < length; i++) {
      if (p_intValue == l_strList[i].value) {
        l_strList[i].checked = p_boolSelect;
      }
    }
  }

  public SelectUnSelectAllElement(p_strID, p_boolChecked) {
    var l_strList = <any>document.getElementsByName(p_strID);
    for (var i = 0, length = l_strList.length; i < length; i++) {
      l_strList[i].checked = p_boolChecked;
    }
  }

  public SelectUnselectAllButOne(p_strID, p_intValue, p_boolSelect) {

    var l_strList = <any>document.getElementsByName(p_strID);

    for (var i = 0, length = l_strList.length; i < length; i++) {

      if (p_intValue == l_strList[i].value) {
        l_strList[i].checked = p_boolSelect;

      }
      else {
        l_strList[i].checked = !p_boolSelect;
      }
    }
  }

  public CheckIfSelectedAnyElement(p_strID) {
    var l_boolIsSelectedAny = false;
    var l_strList = <any>document.getElementsByName(p_strID);

    for (var i = 0, length = l_strList.length; i < length; i++) {
      if (l_strList[i].checked) {
        l_boolIsSelectedAny = true;
      }
    }
    return l_boolIsSelectedAny;
  }

  public CheckIfSelectedAllElement(p_strID) {
    var l_boolIsSelectedAll = true;
    var l_strList = <any>document.getElementsByName(p_strID);

    for (var i = 0, length = l_strList.length; i < length; i++) {
      if (l_strList[i].checked) {

      }
      else {
        l_boolIsSelectedAll = false;
      }
    }
    return l_boolIsSelectedAll;
  }

  //MM::
  public GetCurrentFiscalYear() {
    var l_oDate = new Date();
    var l_intMonth = l_oDate.getMonth();
    var l_intYear = l_oDate.getFullYear();
    if (l_intMonth < 3)
      l_intYear = l_intYear - 1;
    return l_intYear;
  }

  public GetCurrentMonth() {
    var l_oDate = new Date();
    var l_intMonth = l_oDate.getMonth() + 1;
    return l_intMonth;
  }

  public GetPreviousMonth() {
    var l_intMonth = this.GetCurrentMonth();
    if (l_intMonth == 1)
      l_intMonth = 12;
    else
      l_intMonth -= 1;
    return l_intMonth;
  }

  public GetCurrentQuarter(p_intMonth) {
    var l_intQuarter = 4;
    if (p_intMonth > 3 && p_intMonth < 7)
      l_intQuarter = 1;
    if (p_intMonth > 6 && p_intMonth < 10)
      l_intQuarter = 2;
    if (p_intMonth > 9 && p_intMonth < 13)
      l_intQuarter = 3;

    return l_intQuarter;
  }

  public GetCurrentFiscalYearWithSlashes(p_intYear) {
    var p_strYear = p_intYear.toString();
    var l_intLastTwoDigits = parseInt(p_strYear.slice(-2));
    l_intLastTwoDigits = l_intLastTwoDigits + 1;

    p_strYear = p_strYear + '/' + l_intLastTwoDigits.toString();
    return p_strYear;
  }

  //////////// AR: Checkboxes/RadioButtons functions ends /////////


  /** Gets the DaysPerMonth array, returns value of index corresponding to month number */
  public GetDaysOfMonth(p_intMonth: number, p_intYear: number): number {

    /* Check leap years if February */
    if (p_intMonth == 1 && this.IsLeapYear(p_intYear)) {
      return 29;
    }

    /** Return the number of days, corresponding to that month */
    return [31, 28, 31, 30, 31, 30,
      31, 31, 30, 31, 30, 31][p_intMonth];
  }

  /** Returns true if leap year */
  public IsLeapYear(p_intYear): boolean {
    return ((p_intYear % 4 == 0) && (p_intYear % 100 != 0)) || (p_intYear % 400 == 0);
  }

  public DoesUserHaveAccess() {
    var l_boolHasAccess = false;

    if (this.SiteUserID == 639)
      l_boolHasAccess = true;

    //l_boolHasAccess = false;
    return l_boolHasAccess;
  }

  public GetTheTimeWithAMOrPMFormat(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ' : ' + minutes + ' ' + ampm;
    return strTime;
  }

  public CheckIsUserLoggedIn() {

    let data = {} as any;
    var l_strAddress = window.location.href;
    var l_strPathName = window.location.pathname;
    data.CompleteURL = l_strAddress;
    data.PageURL = l_strPathName;
    data.BaseURL = this.baseUrl;

    this.http.post(this.baseUrl + 'api/SiteUser/CheckLoginUserDetails', data).subscribe(result => {
      var l_arrResponse = result as any;
      if (l_arrResponse[0].Status == 1) {

        if (l_arrResponse[0].Role == 'Admin' || l_arrResponse[0].Role == 'MasterAdmin')
          this.IsAdmin = true;
        else if (l_arrResponse[0].Role == 'JLR' || l_arrResponse[0].Role == 'JLRReadOnly')
          this.IsJLR = true;
        else if (l_arrResponse[0].Role == 'Dealer' || l_arrResponse[0].Role == 'DealerReadOnly')
          this.IsDealer = true;

        this.SiteUserID = l_arrResponse[0].SiteUserID;
        this.UserEmail = l_arrResponse[0].UserEmail;
        this.IsReadOnly = l_arrResponse[0].IsReadOnly;
        this.IsFinanceManager = l_arrResponse[0].IsFinanceManager;
        this.CanApproveAndSubmit = l_arrResponse[0].CanApproveAndSubmit;
        this.IsFinanceManager = l_arrResponse[0].IsFinanceManager;
        this.IsNonTechnicalAssessor = l_arrResponse[0].IsNonTechnicalAssessor;
        this.IsNonTechnicalTrainer = l_arrResponse[0].IsNonTechnicalTrainer;
        this.CanManageDashboardImage = l_arrResponse[0].CanManageDashboardImage;
        this.IsNonTechnicalTrainer = this.IsNonTechnicalTrainer;
        this.AccessStatus = l_arrResponse[0].AccessStatus;
        this.PFIDealerID = l_arrResponse[0].PFIDealerID;

      }
      else {
        var l_strAddress = window.location.href;
        var l_strSearch = window.location.search;
        var l_strPathName = window.location.pathname;
        if (l_strSearch != '' && (l_strAddress.toLocaleLowerCase().indexOf('code') > -1 || l_strAddress.indexOf('Code') > -1 || l_strAddress.indexOf('forgotpassword') > -1 || l_strAddress.indexOf('resetpassword') > -1)) {
          //this.ShowAlert('User with code.');
          console.log('User with code.');
        }
        else if (l_strAddress.indexOf('login') == -1 && l_strPathName && l_strPathName != '' && l_strPathName != '/') {
          this.ShowAlert('Your session has expired. Please login again to continue.');
          window.location.href = 'login';
        }
      }
    }, error => console.error(error));

  }

  public GetBasePathName() {
    let data = {} as any;
    var l_strAddress = window.location.href;
    var l_strPathName = window.location.pathname;
    data.CompleteURL = l_strAddress;
    data.PageURL = l_strPathName;
    data.BaseURL = this.baseUrl;
    return data;
  }

  public HandleLoggedInUserResponse(l_arrResponse) {
    if (l_arrResponse[0].Status == 1) {
      this.IsAdmin = false;
      this.IsJLR = false;
      this.IsDealer = false;
      if (l_arrResponse[0].Role == 'Admin' || l_arrResponse[0].Role == 'MasterAdmin')
        this.IsAdmin = true;
      else if (l_arrResponse[0].Role == 'JLR' || l_arrResponse[0].Role == 'JLRReadOnly')
        this.IsJLR = true;
      else if (l_arrResponse[0].Role == 'Dealer' || l_arrResponse[0].Role == 'DealerReadOnly')
        this.IsDealer = true;

      this.SiteUserID = l_arrResponse[0].SiteUserID;
      this.UserEmail = l_arrResponse[0].UserEmail;
      this.IsReadOnly = l_arrResponse[0].IsReadOnly;
      this.IsFinanceManager = l_arrResponse[0].IsFinanceManager;
      this.CanApproveAndSubmit = l_arrResponse[0].CanApproveAndSubmit;
      this.IsFinanceManager = l_arrResponse[0].IsFinanceManager;
      this.IsNonTechnicalAssessor = l_arrResponse[0].IsNonTechnicalAssessor;
      this.IsNonTechnicalTrainer = l_arrResponse[0].IsNonTechnicalTrainer;
      this.CanManageDashboardImage = l_arrResponse[0].CanManageDashboardImage;
      this.AccessStatus = l_arrResponse[0].AccessStatus;
      this.PFIDealerID = l_arrResponse[0].PFIDealerID;

    }
    else {
      var l_strAddress = window.location.href;
      var l_strSearch = window.location.search;
      var l_strPathName = window.location.pathname;
      if (l_strSearch != '' && (l_strAddress.toLocaleLowerCase().indexOf('code') > -1 || l_strAddress.indexOf('Code') > -1 || l_strAddress.indexOf('forgotpassword') > -1 || l_strAddress.indexOf('resetpassword') > -1)) {
        //this.ShowAlert('User with code.');
        console.log('User with code.');
      }
      else if (l_strAddress.indexOf('login') == -1 && l_strPathName && l_strPathName != '' && l_strPathName != '/') {
        this.ShowAlert('Your session has expired. Please login again to continue.');
        window.location.href = 'login';
      }
    }
  }

  public handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return this.throwError(
      'Something bad happened; please try again later.');
  };
  throwError(a) { }


  public SanitizerHTML(p_Text) {
    return this.Sanitizer.sanitize(SecurityContext.HTML, p_Text);
  }

  public SetMasterAnimationV2(p_boolShow) {
    //if (p_boolShow)
    //  (<HTMLInputElement>document.getElementById('loader')).style.display = 'flex';
    //else
    //  (<HTMLInputElement>document.getElementById('loader')).style.display = 'none';
  }

  public GetFileIconToDisplay(FilePath: any) {
    var IconURL = 'Default/img/NoImage.jpg';
    var parts = FilePath.split('.');
    var ext = parts[parts.length - 1];
    switch (ext.toLowerCase()) {
      case 'jpeg':
        IconURL = FilePath;
        break;
      case 'jpg':
        IconURL = FilePath;
        break;
      case 'png':
        IconURL = FilePath;
        break;
      case 'tif':
        IconURL = FilePath;
        break;
      case 'tiff':
        IconURL = FilePath;
        break;
      case 'pdf':
        IconURL = 'Default/img/pdficon.jpg';
        break;
      case 'docx':
        IconURL = 'Default/img/Word.jpg';
        break;
      case 'doc':
        IconURL = 'Default/img/Word.jpg';
        break;
      case 'xlsx':
        IconURL = 'Default/img/xls_icon.png';
        break;
      case 'xls':
        IconURL = 'Default/img/xls_icon.png';
        break;
      case 'pptx':
        IconURL = 'Default/img/ppt.png';
        break;
      case 'ppt':
        IconURL = 'Default/img/ppt.png';
        break;
      case 'wav':
        IconURL = 'Default/img/audio.png';
        break;
      case 'mid':
        IconURL = 'Default/img/audio.png';
        break;
      case 'midi':
        IconURL = 'Default/img/audio.png';
        break;
      case 'wma':
        IconURL = 'Default/img/audio.png';
        break;
      case 'mp3':
        IconURL = 'Default/img/audio.png';
        break;
      case 'ogg':
        IconURL = 'Default/img/audio.png';
        break;
      case 'rma':
        IconURL = 'Default/img/audio.png';
        break;
      case 'au':
        IconURL = 'Default/img/audio.png';
        break;
      case 'ea':
        IconURL = 'Default/img/audio.png';
        break;
      case 'avi':
        IconURL = 'Default/img/video.png';
        break;
      case 'mp4':
        IconURL = 'Default/img/video.png';
        break;
      case 'divx':
        IconURL = 'Default/img/video.png';
        break;
      case 'wmv':
        IconURL = 'Default/img/video.png';
        break;
      case 'mkv':
        IconURL = 'Default/img/video.png';
        break;
      case 'flv':
        IconURL = 'Default/img/video.png';
        break;
      case 'avi':
        IconURL = 'Default/img/video.png';
        break;
      case 'vob':
        IconURL = 'Default/img/video.png';
        break;
      case 'ogv':
        IconURL = 'Default/img/video.png';
        break;
      case 'wmv':
        IconURL = 'Default/img/video.png';
        break;
      case 'm4v':
        IconURL = 'Default/img/video.png';
        break;
      case 'mov':
        IconURL = 'Default/img/video.png';
        break;
      case 'wmv':
        IconURL = 'Default/img/video.png';
        break;
      default:
        IconURL = 'Default/img/NoImage.jpg';
    }

    return IconURL;
  }

  public GenerateUniqueGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  public IsFileSizeLesserThanAlowedSizeMB(OrignalFileSize, p_intAllowedSizeType, p_intAllowedSize) {
    var IsValidSize = false;
    var l_decSize = this.FileFormatAndSize(OrignalFileSize);
    var SizeCharacters = l_decSize.substr(l_decSize.length - 2);
    l_decSize = parseFloat(l_decSize.slice(0, -2));
    if ((l_decSize <= p_intAllowedSize && SizeCharacters == p_intAllowedSizeType) || SizeCharacters == "KB" || SizeCharacters == "es" || SizeCharacters == "te") {
      IsValidSize = true;
    }
    return IsValidSize;
  }

  public FileFormatAndSize(bytes) {
    if (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + "GB"; }
    else if (bytes >= 1048576) { bytes = (bytes / 1048576).toFixed(2) + "MB"; }
    else if (bytes >= 1024) { bytes = (bytes / 1024).toFixed(2) + "KB"; }
    else if (bytes > 1) { bytes = bytes + "bytes"; }
    else if (bytes == 1) { bytes = bytes + "byte"; }
    else { bytes = "0 bytes"; }
    return bytes;
  }

  public GetCurrentYear() {
    var l_intYear = new Date().getFullYear();
    return l_intYear;
  }

  public AddLoginLog(Type, Data) {
    let data = {} as any;
    data.Type = Type;
    data.Data = Data;
    this.http.post(this.baseUrl + 'api/SiteUser/AddLoginLogsData', data).subscribe(result => {
    }, error => console.error(error));
  }

}



// WEBPACK FOOTER //
// ./src/app/SharedComponents/Default.ts